import * as React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { Bar, BarDivider, BarNav, BarNavLink, BarNavPosition, Icon } from '@abb/common-ux';

export class LayoutComponent extends React.Component<any, any> {
  render() {
    let AdminTab = <div />;

    let userBarNav = (
      <BarNav position={BarNavPosition.Right}>
        <BarNavLink to='/Login'>Log In</BarNavLink>
      </BarNav>
    );

    if (this.props.loggedInUser) {
      const profile = this.props.loggedInUser.profile;
      userBarNav = (
        <BarNav position={BarNavPosition.Right}>
          <BarDivider orientation='vertical' />
          <BarNavLink to='/'><Icon icon='user' /> {profile.name ? profile.name : profile.email}</BarNavLink>
          <BarDivider orientation='vertical' />
          <BarNavLink to='/Logout'><Icon icon='log_out' /></BarNavLink>
        </BarNav>
      );
      if (this.props.userPermissions && this.props.userPermissions.isAdmin) {
        AdminTab = (
          <BarNav>
            <BarNavLink to='/UserManagement'>User Management</BarNavLink>
          </BarNav>
        );
      }
    }

    return (
      <div>
        <Bar productName='License Portal'>
          <BarNav />
          {AdminTab}
          {userBarNav}
        </Bar>
        <div className='container-fluid'>
          {this.props.children}
        </div>
      </div>
    );
  }
}
export default withRouter(connect(mapStateToProps)(LayoutComponent) as any);

function mapStateToProps(store: any) {
  return {
    loggedInUser: store.userState.loggedInUser,
    userPermissions: store.userState.userPermissions
  };
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/shared/components/Layout/Layout.tsx